var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSvgFile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 17,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.175 3.72L10.241.784a1.356 1.356 0 00-.958-.397H1.371C.622.388.015.995.015 1.744v13.557c0 .75.607 1.356 1.356 1.356h10.846c.749 0 1.356-.607 1.356-1.356V4.678c0-.36-.143-.704-.398-.958zm-7.059 9.887h-3.05a.678.678 0 110-1.356h3.05a.678.678 0 010 1.356zm3.05-2.712h-6.1a.678.678 0 110-1.355h6.1a.678.678 0 010 1.355zm0-2.711h-6.1a.678.678 0 110-1.356h6.1a.678.678 0 010 1.356z",
    fill: "#fff"
  })));
}
export default SvgSvgFile;